import { GlobalStore, UserStore } from '@roc/feature-app-core';
import { borrowerExpMapping, LoanSubType } from '@roc/feature-utils';
import { SinglePropertyRentalPropertiesStore } from './properties/singlePropertyRentalPropertiesStore';
import { QuoteTypeStore } from './quoteTypeStore';
import { SinglePropertyRentalLoanEconomicsStore } from './loanEconomics/singlePropertyRentalLoanEconomicsStore';
import { SinglePropertyStore } from '@roc/feature-loans';
import PricerStore from './singlePropertyPricer/pricerStore';
import PricerSummaryStore from './singlePropertyPricer/pricerSummaryStore';
import { LoanQuoteData } from '../types/LoanQuoteData';
import { getCompletePropertyAddress } from '@roc/ui/utils';

export class SinglePropertyRentalQuoteStore extends QuoteTypeStore {
  constructor(globalStore: GlobalStore, userStore: UserStore) {
    super(globalStore, userStore);
    this.loanSubtype = LoanSubType.SINGLE_PROPERTY;
    this.propertiesStore = new SinglePropertyRentalPropertiesStore(
      this.globalStore, this.loanSubtype
    );
    this.loanEconomicsStore = new SinglePropertyRentalLoanEconomicsStore(
      this.globalStore,
      this,
      this.userStore
    );
    this.pricerStore = new PricerStore(globalStore, this, true);
    this.pricerSummaryStore = new PricerSummaryStore(globalStore, this, userStore)
  }

  getLoanQuoteData(): LoanQuoteData {
    const loanQuoteData = super.getLoanQuoteData();

    const pricerFields = this.pricerStore.getFormValues();
    const propertyFields = this.propertiesStore.propertyFormStores[0].getFormValues();

    const propertyAddress = getCompletePropertyAddress(propertyFields);
    const totalEstimatedAsIsValue = propertyFields.currentMarketValue || pricerFields.totalEstimatedAsIsValue;
    const propertyCounty = propertyFields.county.replace(/, \w{2}$/, "");
    const acquisitionDate = propertyFields.purchaseDate;
    const totalAcquisitionCost = propertyFields.purchasePrice;
    const completedRenovations = propertyFields.constructionRenoSpendToDate;
    const calculatedExpenses = (Number(propertyFields.annualHOAProvidedAtOrigination) ?? 0) + (Number(propertyFields.annualTaxes) ?? 0) + (Number(propertyFields.annualInsurance) ?? 0);
    const monthlyExpenses = calculatedExpenses / 12;
    const monthlyRent = propertyFields.monthlyMarketRent || pricerFields.totalGrossMonthlyRent;

    return {
      ...loanQuoteData,
      propertyAddress,
      totalEstimatedAsIsValue,
      propertyCounty,
      acquisitionDate,
      totalAcquisitionCost,
      completedRenovations,
      monthlyExpenses,
      monthlyRent,
    };
  }
}
